import { UncastedPhysicalTAdd } from '@goldwasserexchange/oblis-frontend-utils';
import ouiStyle from '@goldwasserexchange/oui-style';
import ouiDom from '@goldwasserexchange/oui-dom';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { Trans } from '@lingui/macro';
import * as React from 'react';
import { CurrentTAdd } from '../../../tAdd';
import {
  NewsLetterInnerContainer,
  SubmitButton,
} from './components';

const whiteList: (keyof UncastedPhysicalTAdd | 'T_ADD_EMAIL_PRINCIPAL')[] = [
  'FIRSTNAME',
  'NAME_1',
  'T_ADD_EMAIL_PRINCIPAL',
];

export const NewsLetterSection = (props: {
  index: number,
}) => {
  const {
    index,
  } = props;
  return (
    <ouiDom.HeadingSection.HeadingSection
      index={index}
      name="NewsLetter"
      container={ouiStyle.Constants.Container.lg}
      display={ouiStyle.Constants.DisplayProp.flex}
      flexDirection={[ouiStyle.Constants.InFlexDirectionProp.col, undefined, undefined, ouiStyle.Constants.InFlexDirectionProp.row, undefined, undefined]}
      paddingHorizontal="simple"
      paddingVertical={4}
    >
      <TopModel name="HeadingSectionHeadingContainer">
        {NewsLetterInnerContainer}
      </TopModel>
      <TopModel
        name="HeadingSectionTitleContainer-2"
        color={ouiStyle.Constants.Colors.accent}
        fontSize="s"
      >
        {ouiDom.HeadingSection.DomH2}
      </TopModel>

      <TopModel
        name="HeadingSectionTitleContent-NewsLetter"
      >
        <Trans>
          Restez informé de l'actualité financière et de toutes nos promotions
        </Trans>
      </TopModel>
      <NewsLetterInnerContainer>
        <CurrentTAdd
          whiteList={whiteList}
        />
      </NewsLetterInnerContainer>
      <NewsLetterInnerContainer>
        <SubmitButton />
      </NewsLetterInnerContainer>
    </ouiDom.HeadingSection.HeadingSection>
  );
};
